export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10945.0da1f29f.jpg";